module.exports = __webpack_public_path__ + "static/media/turing-worldwide.a328b1e6.png";